import { SkuFormData } from "@/components/screens/ProductFormPage/types";
import { IKitComponentInput } from "@/interfaces/kit.interface";

export const buildDefaultKit = (
  parentSKU: SkuFormData,
  componentSkuId: number
): IKitComponentInput => {
  return {
    skuId: parentSKU.id,
    componentSkuId,
    quantity: 0,
    referenceSkuName: parentSKU.title,
    active: true,
  };
};
